exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".letter-container[data-v-b1b63ec6]{padding:1em;height:100%;overflow-y:auto}.sidebar-cards[data-v-b1b63ec6]{max-width:300px;float:left;margin-right:1em}.sent-letter[data-v-b1b63ec6]{overflow:hidden;padding:1em;background-color:#f8f9fa;border-radius:8px;min-height:200px}.letter-meta[data-v-b1b63ec6]{margin-bottom:.5em;font-size:.9em}.letter-body[data-v-b1b63ec6]{margin-top:1em;font-size:.9em;text-align:left}", ""]);

// exports
